<template>
  <div class="officialWebsiteList vheight">
    <div class="box-card">
      <div class="tx-c ft30 ft-w">物业服务评价信息查询</div>
      <el-tabs v-model="activeName" @tab-click="handleTabClick">
        <div class="search-with-select">
          <div class="select">
            <el-select
              v-model="selectValue"
              placeholder="请选择"
              @change="handleSelect"
            >
              <el-option label="评价情况" value="1"></el-option>
              <el-option label="基础信息" value="2"></el-option>
              <el-option
                label="良好信息"
                value="3"
                v-if="isShowOption.Good"
              ></el-option>
              <el-option
                label="不良信息"
                value="4"
                v-if="isShowOption.Bad"
              ></el-option>
              <el-option
                label="风险名单"
                value="5"
                v-if="isShowOption.Risk"
              ></el-option>
              <el-option label="激励名单"
                         value="6"
                         v-if="activeName == 'first'&&isShowOption.Incentive"></el-option>
            </el-select>
          </div>
          <div class="search" v-if="activeName == 'first'">
            <el-input
              placeholder="物业服务企业"
              v-model="companyName"
              clearable
            >
              <el-button
                class="button"
                slot="append"
                icon="el-icon-search"
                @click="handleSearch"
              ></el-button>
            </el-input>
          </div>
          <div class="search" v-else>
            <el-input
              placeholder="请搜索物业项目名称或项目负责人"
              v-model="managerName"
              clearable
            >
              <el-button
                class="button"
                slot="append"
                icon="el-icon-search"
                @click="handleSearch"
              ></el-button>
            </el-input>
          </div>
        </div>
        <el-tab-pane label="物业服务企业" name="first"></el-tab-pane>
        <el-tab-pane label="项目负责人" name="second"></el-tab-pane>
        <template v-if="activeName == 'first'">
          <div class="container" v-if="selectValue == '1'">
            <el-table
              v-loading="loading"
              element-loading-text="数据正在加载中，请稍候"
              key="companyEvaluation"
              ref="multipleTable"
              :data="companyEvaluationList"
              tooltip-effect="dark"
              style="width: 100%"
              height="100%"
              :header-cell-style="{ background: 'rgb(241,243,255)' }"
              stripe
              border
              :highlight-current-row="true"
            >
              <!-- 加载的时候不要显示暂无数据 -->
              <template slot="empty">
                <span v-if="loading"></span>
                <span v-else>暂无数据</span>
              </template>
              <el-table-column
                label="序号"
                width="80"
                type="index"
                v-bind:index="indexMethod"
                :key="1"
                align="center"
                fixed
              ></el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="CompanyName"
                label="物业服务企业"
                min-width="150"
                header-align="center"
                :key="2"
                align="center"
                fixed
              >
                <template slot-scope="scope">{{
                  scope.row.CompanyName || '--'
                }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="CompanyCode"
                label="物业服务企业统一社会信用代码"
                min-width="180"
                :key="3"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.CompanyCode || '--'
                }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="TotalScore"
                label="得分"
                min-width="120"
                :key="4"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.TotalScore || '0'
                }}</template>
              </el-table-column>
              <!-- <el-table-column align="center"
                               width="170"
                               prop="MangerBindRate"
                               label="项目负责人绑定情况">
                <template slot-scope="scope">
                  <div>
                    {{ scope.row.MangerBindRate === 1 ? '√' : 'X' }}
                  </div>
                </template>
              </el-table-column> -->
              <!--              <el-table-column-->
              <!--                  :show-overflow-tooltip="true"-->
              <!--                  prop="RankNo"-->
              <!--                  label="评价排名"-->
              <!--                  min-width="120"-->
              <!--                  :key="5"-->
              <!--                  align="center"-->
              <!--              >-->
              <!--                <template slot-scope="scope">-->
              <!--                  <el-popover-->
              <!--                      v-if="scope.row.IsDangerText"-->
              <!--                      placement="bottom"-->
              <!--                      width="300"-->
              <!--                      trigger="hover"-->
              <!--                      content="根据《深圳市物业服务评价管理办法》第三十八条规定，被纳入风险名单的物业服务企业（项目负责人），不参与纳入时所在自然年度的物业服务评价和等级评定，其评价排名和等级评定情况显示为“-”。">-->
              <!--                    <el-button slot="reference" type="text">-</el-button>-->
              <!--                  </el-popover>-->
              <!--                  <span v-else>{{ scope.row.RankNo || '&#45;&#45;' }}</span>-->
              <!--                </template>-->
              <!--              </el-table-column>-->

              <el-table-column
                prop="RankNo"
                min-width="150"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot="header" slot-scope="scope">
                  <span>评价排名</span>
                  <el-popover
                    placement="top-start"
                    title=""
                    width="330"
                    trigger="hover"
                  >
                    <div style="width: 300px">
                      <p>1. 如得分相同，不良信息减分少者排前。</p>
                      <p>
                        2.
                        如不良信息得分一样（含均为0分），良好信息加分多者排前。
                      </p>
                      <p>
                        3.
                        如良好信息得分一样（含均为0分），表一中的“业主满意度评价”指标得分高者排前。
                      </p>
                      <p>4. 如“业主满意度评价”指标得分仍一样，则并列排名。</p>
                    </div>
                    <span slot="reference">
                      <svg
                        t="1657620339773"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="2256"
                        width="20"
                        height="20"
                      >
                        <path
                          d="M481.5 65.5c-229.2 0-415 185.8-415 415s185.8 415 415 415 415-185.8 415-415-185.8-415-415-415z m0 766.2c-193.6 0-351.2-157.5-351.2-351.2s157.5-351.2 351.2-351.2 351.2 157.5 351.2 351.2-157.6 351.2-351.2 351.2z"
                          p-id="2257"
                          fill="#efb02e"
                        ></path>
                        <path
                          d="M481.5 257.1c-77.2 0-141.6 54.8-156.4 127.7h66.5c13.2-37.1 48.3-63.8 89.9-63.8 52.8 0 95.8 43 95.8 95.8 0 41.6-26.8 76.7-63.8 89.9v5.9h-63.8v127.7h63.8v-67.1c72.9-14.8 127.7-79.2 127.7-156.4-0.1-88.3-71.6-159.7-159.7-159.7zM449.5 704h63.8v63.8h-63.8z"
                          p-id="2258"
                          fill="#efb02e"
                        ></path>
                      </svg>
                    </span>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-popover
                    v-if="scope.row.IsDangerText"
                    placement="bottom"
                    width="300"
                    trigger="hover"
                    content="根据《深圳市物业服务评价管理办法》第三十八条规定，被纳入风险名单的物业服务企业（项目负责人），不参与纳入时所在自然年度的物业服务评价和等级评定，其评价排名和等级评定情况显示为“-”。"
                  >
                    <el-button slot="reference" type="text">-</el-button>
                  </el-popover>
                  <span v-else>{{ scope.row.RankNo || '--' }}</span>
                </template>
              </el-table-column>

              <!-- <el-table-column
                  :show-overflow-tooltip="true"
                  prop="Level"
                  label="本年度评价等级（临时）"
                  min-width="180"
                  align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.IsDangerText">-</span>
                  <span v-else>{{ scope.row.Level || '--' }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                :show-overflow-tooltip="true"
                prop="LastYearLevel"
                label="上一年度评价等级"
                min-width="150"
                :key="6"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.LastYearLevel || '--'
                }}</template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="100"
                :key="7"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <ps-detail @click="handleDetails(scope.row)">查看</ps-detail>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="container" v-else-if="selectValue == '2'">
            <el-table
              v-loading="loading"
              element-loading-text="数据正在加载中，请稍候"
              key="companyBase"
              ref="multipleTable"
              :data="companyBaseInfoList"
              tooltip-effect="dark"
              style="width: 100%"
              height="100%"
              :header-cell-style="{ background: 'rgb(241,243,255)' }"
              stripe
              border
              :highlight-current-row="true"
            >
              <template slot="empty">
                <span v-if="loading"></span>
                <span v-else>暂无数据</span>
              </template>
              <el-table-column
                label="序号"
                width="80"
                type="index"
                v-bind:index="indexMethod"
                :key="8"
                align="center"
                fixed
              ></el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="OrgName"
                label="物业服务企业"
                min-width="210"
                header-align="center"
                :key="9"
                align="center"
                fixed
              >
                <template slot-scope="scope">{{
                  scope.row.OrgName || '--'
                }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="OrgCode"
                label="物业服务企业统一社会信用代码"
                min-width="180"
                :key="10"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.OrgCode || '--'
                }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="TotalScore"
                label="得分"
                min-width="90"
                :key="11"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.TotalScore || '0'
                }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="SuperintendentBind"
                label="企业负责人绑定"
                min-width="130"
                :key="12"
                align="center"
              >
                <template slot-scope="scope">
                  {{
                    scope.row.SuperintendentBind == true
                      ? '已绑定'
                      : '未绑定' || '--'
                  }}
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="CommonAccountOpenRate"
                label="共有资金开户情况"
                min-width="180"
                :key="13"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.CommonAccountOpenRate">
                    {{
                      Number(scope.row.CommonAccountOpenRate * 100).toFixed(2)
                    }}%
                  </span>
                  <span v-else>0.00%</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="MangerBindRate"
                label="项目负责人绑定情况"
                min-width="180"
                :key="14"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.MangerBindRate">
                    {{ Number(scope.row.MangerBindRate * 100).toFixed(2) }}%
                  </span>
                  <span v-else>0.00%</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="DataSupplementationRate"
                label="物业合同备案情况"
                min-width="180"
                :key="15"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.DataSupplementationRate">
                    {{
                      Number(scope.row.DataSupplementationRate * 100).toFixed(
                        2
                      )
                    }}%
                  </span>
                  <span v-else>0.00%</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="SatisfactionScore"
                label="满意度得分"
                min-width="120"
                :key="16"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.SatisfactionScore">
                    {{ Number(scope.row.SatisfactionScore).toFixed(2) }}
                  </span>
                  <span v-else>0.00</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="PublicRate"
                label="信息公开率"
                min-width="120"
                :key="17"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.PublicRate">
                    {{ Number(scope.row.PublicRate * 100).toFixed(2) }}%
                  </span>
                  <span v-else>0.00%</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="SafetyCompletionRate"
                label="安全检查完成率"
                min-width="150"
                :key="18"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.SafetyCompletionRate">
                    {{
                      Number(scope.row.SafetyCompletionRate * 100).toFixed(2)
                    }}%
                  </span>
                  <span v-else>0.00%</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="EvaluationFeedbackRate"
                label="评价反馈率"
                min-width="150"
                :key="19"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.EvaluationFeedbackRate">
                    {{
                      Number(scope.row.EvaluationFeedbackRate * 100).toFixed(2)
                    }}%
                  </span>
                  <span v-else>0.00%</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="NotificationResponseRate"
                label="通知发布响应率"
                min-width="160"
                :key="20"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.NotificationResponseRate">
                    {{
                      Number(scope.row.NotificationResponseRate * 100).toFixed(
                        2
                      )
                    }}%
                  </span>
                  <span v-else>0.00%</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="SubmitTimes"
                label="年度统计报表"
                min-width="150"
                :key="21"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.SubmitTimes">
                    {{ scope.row.SubmitTimes }}次
                  </span>
                  <span v-else>0次</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="CommunityEvaluateScore"
                label="街道社区评价"
                min-width="160"
                :key="111"
                align="center"
              >
                <template slot-scope="scope">{{
                  Number(scope.row.CommunityEvaluateScore).toFixed(2) || '0'
                }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ProfessionalCompletionRate"
                label="参与专业能力测评情况"
                min-width="180"
                :key="22"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.ProfessionalCompletionRate">
                    {{
                      Number(
                        scope.row.ProfessionalCompletionRate * 100
                      ).toFixed(2)
                    }}%
                  </span>
                  <span v-else>0.00%</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="EmployeeSelectType"
                label="从业人员情况"
                min-width="120"
                :key="23"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.EmployeeSelectType">
                    {{ Number(scope.row.EmployeeSelectType * 5) }}分
                  </span>
                  <span v-else>0分</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="100"
                :key="24"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <ps-detail @click="handleDetails(scope.row)">查看</ps-detail>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="container" v-else-if="selectValue == '3'">
            <el-table
              v-loading="loading"
              element-loading-text="数据正在加载中，请稍候"
              key="companyGood"
              ref="multipleTable"
              :data="companyGoodList"
              tooltip-effect="dark"
              style="width: 100%"
              height="100%"
              :header-cell-style="{ background: 'rgb(241,243,255)' }"
              stripe
              border
              :highlight-current-row="true"
            >
              <template slot="empty">
                <span v-if="loading"></span>
                <span v-else>暂无数据</span>
              </template>
              <el-table-column
                label="序号"
                width="80"
                type="index"
                v-bind:index="indexMethod"
                :key="24"
                align="center"
                fixed
              ></el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="OrgName"
                label="物业服务企业"
                header-align="center"
                min-width="180"
                :key="25"
                align="center"
                fixed
              ></el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="OrgCode"
                label="物业服务企业统一社会信用代码"
                min-width="180"
                :key="26"
                align="center"
              ></el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ApplyContent"
                label="良好信息事项"
                min-width="180"
                :key="27"
                align="center"
              >
                <template slot-scope="scope">
                  {{
                    scope.row.LevelContent && scope.row.LevelContentTwo
                      ? scope.row.ApplyContent +
                        '--' +
                        scope.row.LevelContent +
                        '-' +
                        scope.row.LevelContentTwo
                      : scope.row.LevelContent
                      ? scope.row.ApplyContent + '--' + scope.row.LevelContent
                      : scope.row.ApplyContent
                  }}
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="StreetName"
                label="认定日期"
                min-width="120"
                :key="28"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.ThatDate | formatDate('yyyy-MM-dd') }}
                </template>
              </el-table-column>
              <!-- <el-table-column
                :show-overflow-tooltip="true"
                prop="Score"
                label="计分"
                min-width="120"
                :key="29"
                align="center"
              >
                <template slot-scope="scope">
                  <span>{{ '+' + scope.row.Score }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ExpirationDate"
                label="公示截止日期"
                min-width="150"
                :key="30"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.ExpirationDate == '9999-12-31T23:59:59'"
                    >长期有效</span
                  >
                  <span v-else>{{
                    scope.row.ExpirationDate | formatDate('yyyy-MM-dd')
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="100"
                :key="31"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <ps-detail @click="handleDetails(scope.row)">查看</ps-detail>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="container" v-else-if="selectValue == '4'">
            <el-table
              v-loading="loading"
              element-loading-text="数据正在加载中，请稍候"
              key="companyBad"
              ref="multipleTable"
              :data="companyBadList"
              tooltip-effect="dark"
              style="width: 100%"
              height="100%"
              empty-text="暂无不良信息计分"
              :header-cell-style="{ background: 'rgb(241,243,255)' }"
              stripe
              border
              :highlight-current-row="true"
            >
              <template slot="empty">
                <span v-if="loading"></span>
                <span v-else>暂无数据</span>
              </template>
              <el-table-column
                label="序号"
                width="80"
                type="index"
                v-bind:index="indexMethod"
                :key="32"
                align="center"
                fixed
              ></el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="OrgName"
                label="物业服务企业"
                header-align="center"
                min-width="180"
                :key="33"
                align="center"
                fixed
              ></el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="OrgCode"
                label="物业服务企业统一社会信用代码"
                min-width="180"
                :key="34"
                align="center"
              ></el-table-column>
              <!-- <el-table-column
                  :show-overflow-tooltip="true"
                  prop="ApplyCode"
                  label="不良信息编号"
                  min-width="150"
                  align="center"
              ></el-table-column> -->
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ApplyContent"
                label="不良信息事项"
                min-width="180"
                :key="35"
                align="center"
              >
                <template slot-scope="scope">
                  {{
                    scope.row.LevelContent && scope.row.LevelContentTwo
                      ? scope.row.ApplyContent +
                        '--' +
                        scope.row.LevelContent +
                        '-' +
                        scope.row.LevelContentTwo
                      : scope.row.LevelContent
                      ? scope.row.ApplyContent + '--' + scope.row.LevelContent
                      : scope.row.ApplyContent
                  }}
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ThatDate"
                label="信息录入日期"
                min-width="150"
                :key="36"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.ThatDate | formatDate('yyyy-MM-dd') }}
                </template>
              </el-table-column>
              <!-- <el-table-column
                :show-overflow-tooltip="true"
                prop="Score"
                label="计分"
                min-width="120"
                :key="37"
                align="center"
              ></el-table-column> -->
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ExpirationDate"
                label="公示截止日期"
                min-width="150"
                :key="38"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.ExpirationDate | formatDate('yyyy-MM-dd') }}
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="100"
                :key="39"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <ps-detail @click="handleDetails(scope.row)">查看</ps-detail>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="container" v-else-if="selectValue == '5'">
            <el-table
              v-loading="loading"
              element-loading-text="数据正在加载中，请稍候"
              key="companyRisk"
              ref="multipleTable"
              :data="companyRiskList"
              tooltip-effect="dark"
              style="width: 100%"
              height="100%"
              :header-cell-style="{ background: 'rgb(241,243,255)' }"
              stripe
              border
              :highlight-current-row="true"
            >
              <template slot="empty">
                <span v-if="loading"></span>
                <span v-else>暂无数据</span>
              </template>
              <el-table-column
                label="序号"
                width="80"
                type="index"
                v-bind:index="indexMethod"
                :key="40"
                align="center"
                fixed
              ></el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="OrgName"
                label="物业服务企业"
                header-align="center"
                min-width="180"
                :key="41"
                align="center"
                fixed
              >
                <template slot-scope="scope">{{
                  scope.row.OrgName || '--'
                }}</template>
              </el-table-column>
              <!-- <el-table-column
                :show-overflow-tooltip="true"
                prop="OrgCode"
                label="物业服务企业统一社会信用代码"
                min-width="180"
                :key="42"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.OrgCode || '--'
                }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ThatDate"
                label="纳入日期"
                min-width="120"
                :key="43"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.ThatDate">
                    {{ scope.row.ThatDate | formatDate('yyyy-MM-dd') }}
                  </span>
                  <span v-else>--</span>
                </template>
              </el-table-column> -->
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ApplyContent"
                label="纳入风险名单的情形"
                min-width="180"
                :key="44"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.ApplyContent || '--'
                }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ExpirationDate"
                label="公示截止日期"
                min-width="150"
                :key="45"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.ExpirationDate">{{
                    scope.row.ExpirationDate | formatDate('yyyy-MM-dd')
                  }}</span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="100"
                :key="46"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <ps-detail @click="handleDetails(scope.row)">查看</ps-detail>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="container" v-else-if="selectValue == '6'">
            <el-table
              v-loading="loading"
              element-loading-text="数据正在加载中，请稍候"
              key="encourageList"
              ref="multipleTable"
              :data="encourageList"
              tooltip-effect="dark"
              style="width: 100%"
              height="100%"
              :header-cell-style="{ background: 'rgb(241,243,255)' }"
              stripe
              border
              :highlight-current-row="true"
            >
              <template slot="empty">
                <span v-if="loading"></span>
                <span v-else>暂无数据</span>
              </template>
              <el-table-column
                label="序号"
                width="80"
                type="index"
                v-bind:index="indexMethod"
                :key="40"
                align="center"
                fixed
              ></el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="orgName"
                label="物业服务企业"
                header-align="center"
                min-width="180"
                :key="41"
                align="center"
                fixed
              >
                <template slot-scope="scope">{{
                  scope.row.orgName || '--'
                }}</template>
              </el-table-column>
              <!-- <el-table-column
                :show-overflow-tooltip="true"
                prop="orgCode"
                label="物业服务企业统一社会信用代码"
                min-width="180"
                :key="42"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.orgCode || '--'
                }}</template>
              </el-table-column> -->
            </el-table>
          </div>
        </template>
        <template v-if="activeName == 'second'">
          <div class="container" v-if="selectValue == '1'">
            <el-table
              v-loading="loading"
              element-loading-text="数据正在加载中，请稍候"
              key="managerEvaluation"
              ref="multipleTable"
              :data="managerEvaluationList"
              tooltip-effect="dark"
              style="width: 100%"
              height="100%"
              :header-cell-style="{ background: 'rgb(241,243,255)' }"
              stripe
              border
              :highlight-current-row="true"
            >
              <template slot="empty">
                <span v-if="loading"></span>
                <span v-else>暂无数据</span>
              </template>
              <el-table-column
                label="序号"
                width="80"
                type="index"
                v-bind:index="indexMethod"
                :key="47"
                align="center"
                fixed
              ></el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ManagerName"
                label="项目负责人"
                header-align="center"
                min-width="120"
                :key="48"
                align="center"
                fixed
              >
                <template slot-scope="scope">{{
                  scope.row.ManagerName || '--'
                }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="CompanyName"
                label="所属物业服务企业"
                min-width="180"
                :key="49"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.CompanyName || '--'
                }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="EaAreaName"
                label="在管物业项目"
                min-width="150"
                :key="50"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.EaAreaName || '--'
                }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="TotalScore"
                label="评价得分"
                min-width="150"
                :key="51"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.TotalScore || '0'
                }}</template>
              </el-table-column>
              <!--              <el-table-column-->
              <!--                  :show-overflow-tooltip="true"-->
              <!--                  prop="RankNo"-->
              <!--                  label="评价排名"-->
              <!--                  min-width="150"-->
              <!--                  :key="52"-->
              <!--                  align="center"-->
              <!--              >-->
              <!--                <template slot-scope="scope">-->
              <!--                  <el-popover-->
              <!--                      v-if="scope.row.IsDangerText"-->
              <!--                      placement="bottom"-->
              <!--                      width="300"-->
              <!--                      trigger="hover"-->
              <!--                      content="根据《深圳市物业服务评价管理办法》第三十八条规定，被纳入风险名单的物业服务企业（项目负责人），不参与纳入时所在自然年度的物业服务评价和等级评定，其评价排名和等级评定情况显示为“-”。">-->
              <!--                    <el-button slot="reference" type="text">-</el-button>-->
              <!--                  </el-popover>-->
              <!--                  <span v-else>{{ scope.row.RankNo || '&#45;&#45;' }}</span>-->
              <!--                </template>-->
              <!--              </el-table-column>-->

              <el-table-column
                prop="RankNo"
                min-width="150"
                align="center"
                :show-overflow-tooltip="true"
              >
                <template slot="header" slot-scope="scope">
                  <span>评价排名</span>
                  <el-popover
                    placement="top-start"
                    title=""
                    width="330"
                    trigger="hover"
                  >
                    <div style="width: 300px">
                      <p>1. 如得分相同，不良信息减分少者排前。</p>
                      <p>
                        2.
                        如不良信息得分一样（含均为0分），良好信息加分多者排前。
                      </p>
                      <p>
                        3.
                        如良好信息得分一样（含均为0分），表二中的“业主满意度评价”指标得分高者排前。
                      </p>
                      <p>4. 如“业主满意度评价”指标得分仍一样，则并列排名。</p>
                    </div>
                    <span slot="reference">
                      <svg
                        t="1657620339773"
                        class="icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="2256"
                        width="20"
                        height="20"
                      >
                        <path
                          d="M481.5 65.5c-229.2 0-415 185.8-415 415s185.8 415 415 415 415-185.8 415-415-185.8-415-415-415z m0 766.2c-193.6 0-351.2-157.5-351.2-351.2s157.5-351.2 351.2-351.2 351.2 157.5 351.2 351.2-157.6 351.2-351.2 351.2z"
                          p-id="2257"
                          fill="#efb02e"
                        ></path>
                        <path
                          d="M481.5 257.1c-77.2 0-141.6 54.8-156.4 127.7h66.5c13.2-37.1 48.3-63.8 89.9-63.8 52.8 0 95.8 43 95.8 95.8 0 41.6-26.8 76.7-63.8 89.9v5.9h-63.8v127.7h63.8v-67.1c72.9-14.8 127.7-79.2 127.7-156.4-0.1-88.3-71.6-159.7-159.7-159.7zM449.5 704h63.8v63.8h-63.8z"
                          p-id="2258"
                          fill="#efb02e"
                        ></path>
                      </svg>
                    </span>
                  </el-popover>
                </template>
                <template slot-scope="scope">
                  <el-popover
                    v-if="scope.row.IsDangerText"
                    placement="bottom"
                    width="300"
                    trigger="hover"
                    content="根据《深圳市物业服务评价管理办法》第三十八条规定，被纳入风险名单的物业服务企业（项目负责人），不参与纳入时所在自然年度的物业服务评价和等级评定，其评价排名和等级评定情况显示为“-”。"
                  >
                    <el-button slot="reference" type="text">-</el-button>
                  </el-popover>
                  <span v-else>{{ scope.row.RankNo || '--' }}</span>
                </template>
              </el-table-column>

              <!-- <el-table-column
                  :show-overflow-tooltip="true"
                  prop="Level"
                  label="本年度评价等级（临时）"
                  min-width="180"
                  align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.IsDangerText">-</span>
                  <span v-else>{{ scope.row.Level || '--' }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                :show-overflow-tooltip="true"
                prop="LastYearLevel"
                label="上一年度评价等级"
                min-width="150"
                :key="53"
                align="center"
              ></el-table-column>
              <el-table-column
                label="操作"
                width="100"
                :key="54"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <ps-detail @click="handleDetails(scope.row)">查看</ps-detail>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="container" v-else-if="selectValue == '2'">
            <el-table
              v-loading="loading"
              element-loading-text="数据正在加载中，请稍候"
              key="managerBase"
              ref="multipleTable"
              :data="managerBaseInfoList"
              tooltip-effect="dark"
              style="width: 100%"
              height="100%"
              :header-cell-style="{ background: 'rgb(241,243,255)' }"
              stripe
              border
              :highlight-current-row="true"
            >
              <template slot="empty">
                <span v-if="loading"></span>
                <span v-else>暂无数据</span>
              </template>
              <el-table-column
                label="序号"
                width="80"
                type="index"
                v-bind:index="indexMethod"
                :key="55"
                align="center"
                fixed
              ></el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="MangerName"
                label="项目负责人"
                header-align="center"
                :key="56"
                min-width="130"
                align="center"
                fixed
              >
                <template slot-scope="scope">{{
                  scope.row.MangerName || '--'
                }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="OrgName"
                label="所属物业服务企业"
                min-width="200"
                :key="57"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.OrgName || '--'
                }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="EaAreaName"
                label="在管物业项目"
                min-width="150"
                :key="58"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.EaAreaName || '--'
                }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="TotalScore"
                label="得分"
                min-width="120"
                :key="59"
                align="center"
              >
                <template slot-scope="scope">{{
                  scope.row.TotalScore || '0'
                }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="SuperintendentBind"
                label="绑定身份情况"
                min-width="150"
                :key="60"
                align="center"
              >
                <template slot-scope="scope">
                  {{
                    scope.row.MangerBindRate == 1 ? '已绑定' : '未绑定' || '--'
                  }}
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="CommonAccountOpenRate"
                label="共有资金开户情况"
                min-width="180"
                :key="61"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.CommonAccountOpenRate">
                    {{
                      Number(scope.row.CommonAccountOpenRate * 100).toFixed(2)
                    }}%
                  </span>
                  <span v-else>0.00%</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="DataSupplementationRate"
                label="物业合同备案情况"
                min-width="180"
                :key="62"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.DataSupplementationRate">
                    {{
                      Number(scope.row.DataSupplementationRate * 100).toFixed(
                        2
                      )
                    }}%
                  </span>
                  <span v-else>0.00%</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="SatisfactionScore"
                label="满意度得分"
                min-width="120"
                :key="63"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.SatisfactionScore">
                    {{ Number(scope.row.SatisfactionScore).toFixed(2) }}
                  </span>
                  <span v-else>0.00</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="PublicRate"
                label="信息公开率"
                min-width="120"
                :key="64"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.PublicRate">
                    {{ Number(scope.row.PublicRate * 100).toFixed(2) }}%
                  </span>
                  <span v-else>0.00%</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="SafetyCompletionRate"
                label="安全检查完成率"
                min-width="150"
                :key="65"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.SafetyCompletionRate">
                    {{
                      Number(scope.row.SafetyCompletionRate * 100).toFixed(2)
                    }}%
                  </span>
                  <span v-else>0.00%</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="EvaluationFeedbackRate"
                label="评价反馈率"
                min-width="120"
                :key="66"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.EvaluationFeedbackRate">
                    {{
                      Number(scope.row.EvaluationFeedbackRate * 100).toFixed(2)
                    }}%
                  </span>
                  <span v-else>0.00%</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="NotificationResponseRate"
                label="通知发布响应率"
                min-width="150"
                :key="67"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.NotificationResponseRate">
                    {{
                      Number(scope.row.NotificationResponseRate * 100).toFixed(
                        2
                      )
                    }}%
                  </span>
                  <span v-else>0.00%</span>
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="CommunityEvaluateScore"
                label="街道社区评价"
                min-width="160"
                :key="112"
                align="center"
              >
                <template slot-scope="scope">{{
                  Number(scope.row.CommunityEvaluateScore).toFixed(2) || '0'
                }}</template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ProfessionalCompletionRate"
                label="参与专业能力测评情况"
                min-width="180"
                :key="68"
                align="center"
              >
                <template slot-scope="scope">
                  {{
                    Number(scope.row.ProfessionalCompletionRate * 100).toFixed(
                      2
                    )
                  }}%
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="100"
                :key="69"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <ps-detail @click="handleDetails(scope.row)">查看</ps-detail>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="container" v-else-if="selectValue == '3'">
            <el-table
              v-loading="loading"
              element-loading-text="数据正在加载中，请稍候"
              key="managerGood"
              ref="multipleTable"
              :data="managerGoodList"
              tooltip-effect="dark"
              style="width: 100%"
              height="100%"
              :header-cell-style="{ background: 'rgb(241,243,255)' }"
              stripe
              border
              :highlight-current-row="true"
            >
              <template slot="empty">
                <span v-if="loading"></span>
                <span v-else>暂无数据</span>
              </template>
              <el-table-column
                label="序号"
                width="80"
                type="index"
                v-bind:index="indexMethod"
                :key="70"
                align="center"
                fixed
              ></el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="MangerName"
                label="项目负责人"
                header-align="center"
                min-width="150"
                :key="71"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.MangerName || '--' }}
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="OrgName"
                label="所属物业服务企业"
                min-width="200"
                :key="72"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.OrgName || '--' }}
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ApplyContent"
                label="良好信息事项"
                min-width="200"
                :key="73"
                align="center"
              >
                <template slot-scope="scope">
                  {{
                    scope.row.LevelContent && scope.row.LevelContentTwo
                      ? scope.row.ApplyContent +
                        '--' +
                        scope.row.LevelContent +
                        '-' +
                        scope.row.LevelContentTwo
                      : scope.row.LevelContent
                      ? scope.row.ApplyContent + '--' + scope.row.LevelContent
                      : scope.row.ApplyContent
                  }}
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ThatDate"
                label="认定日期"
                min-width="120"
                :key="74"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.ThatDate">
                    {{ scope.row.ThatDate | formatDate('yyyy-MM-dd') }}
                  </span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                :show-overflow-tooltip="true"
                prop="Score"
                label="计分"
                min-width="100"
                :key="75"
                align="center"
              >
                <template slot-scope="scope">
                  {{ '+' + scope.row.Score || '--' }}
                </template>
              </el-table-column> -->
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ExpirationDate"
                label="公示截止日期"
                min-width="120"
                :key="76"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.ExpirationDate == '9999-12-31T23:59:59'"
                    >长期有效</span
                  >
                  <span v-else>{{
                    scope.row.ExpirationDate | formatDate('yyyy-MM-dd')
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="100"
                :key="77"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <ps-detail @click="handleDetails(scope.row)">查看</ps-detail>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="container" v-else-if="selectValue == '4'">
            <el-table
              v-loading="loading"
              element-loading-text="数据正在加载中，请稍候"
              key="managerBad"
              ref="multipleTable"
              :data="managerBadList"
              tooltip-effect="dark"
              style="width: 100%"
              height="100%"
              empty-text="暂无不良信息计分"
              :header-cell-style="{ background: 'rgb(241,243,255)' }"
              stripe
              border
              :highlight-current-row="true"
            >
              <template slot="empty">
                <span v-if="loading"></span>
                <span v-else>暂无数据</span>
              </template>
              <el-table-column
                label="序号"
                width="80"
                type="index"
                v-bind:index="indexMethod"
                align="center"
                fixed
              ></el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="MangerName"
                label="项目负责人"
                header-align="center"
                min-width="150"
                :key="78"
                align="center"
                fixed
              >
                <template slot-scope="scope">
                  {{ scope.row.MangerName || '--' }}
                </template>
              </el-table-column>
              <!-- <el-table-column
                  :show-overflow-tooltip="true"
                  prop="EaAreaName"
                  label="在管物业项目"
                  min-width="150"
                  align="center"
              ></el-table-column> -->
              <el-table-column
                :show-overflow-tooltip="true"
                prop="OrgName"
                label="所属物业服务企业"
                min-width="180"
                :key="79"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.OrgName || '--' }}
                </template>
              </el-table-column>
              <!-- <el-table-column
                  :show-overflow-tooltip="true"
                  prop="ApplyCode"
                  label="不良信息编号"
                  min-width="150"
                  align="center"
              ></el-table-column> -->
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ApplyContent"
                label="不良信息事项"
                min-width="200"
                :key="80"
                align="center"
              >
                <template slot-scope="scope">
                  {{
                    scope.row.LevelContent && scope.row.LevelContentTwo
                      ? scope.row.ApplyContent +
                        '--' +
                        scope.row.LevelContent +
                        '-' +
                        scope.row.LevelContentTwo
                      : scope.row.LevelContent
                      ? scope.row.ApplyContent + '--' + scope.row.LevelContent
                      : scope.row.ApplyContent
                  }}
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ThatDate"
                label="信息录入日期"
                min-width="150"
                :key="81"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.ThatDate">
                    {{ scope.row.ThatDate | formatDate('yyyy-MM-dd') }}
                  </span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                :show-overflow-tooltip="true"
                prop="Score"
                label="计分"
                min-width="100"
                :key="82"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.Score || '--' }}
                </template>
              </el-table-column> -->
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ExpirationDate"
                label="公示截止日期"
                min-width="120"
                :key="83"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.ExpirationDate">
                    {{ scope.row.ExpirationDate | formatDate('yyyy-MM-dd') }}
                  </span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="100"
                :key="84"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <ps-detail @click="handleDetails(scope.row)">查看</ps-detail>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="container" v-else-if="selectValue == '5'">
            <el-table
              v-loading="loading"
              element-loading-text="数据正在加载中，请稍候"
              key="managerRisk"
              ref="multipleTable"
              :data="managerRiskList"
              tooltip-effect="dark"
              style="width: 100%"
              height="100%"
              :header-cell-style="{ background: 'rgb(241,243,255)' }"
              stripe
              border
              :highlight-current-row="true"
            >
              <template slot="empty">
                <span v-if="loading"></span>
                <span v-else>暂无数据</span>
              </template>
              <el-table-column
                label="序号"
                width="80"
                type="index"
                v-bind:index="indexMethod"
                :key="85"
                align="center"
                fixed
              ></el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="MangerName"
                label="项目负责人"
                header-align="center"
                min-width="150"
                :key="86"
                align="center"
                fixed
              >
                <template slot-scope="scope">
                  {{ scope.row.MangerName || '--' }}
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="OrgName"
                label="所属物业服务企业"
                :key="87"
                min-width="180"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.OrgName || '--' }}
                </template>
              </el-table-column>
              <!-- <el-table-column
                :show-overflow-tooltip="true"
                prop="ThatDate"
                label="纳入日期"
                :key="88"
                min-width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.ThatDate">
                    {{ scope.row.ThatDate | formatDate('yyyy-MM-dd') }}
                  </span>
                  <span v-else>--</span>
                </template>
              </el-table-column> -->
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ApplyContent"
                label="纳入风险名单的情形"
                :key="89"
                min-width="200"
                align="center"
              >
                <template slot-scope="scope">
                  {{ scope.row.ApplyContent || '--' }}
                </template>
              </el-table-column>
              <el-table-column
                :show-overflow-tooltip="true"
                prop="ExpirationDate"
                label="公示截止日期"
                :key="90"
                min-width="150"
                align="center"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.ExpirationDate">
                    {{ scope.row.ExpirationDate | formatDate('yyyy-MM-dd') }}
                  </span>
                  <span v-else>--</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="100"
                :key="91"
                align="center"
                fixed="right"
              >
                <template slot-scope="scope">
                  <ps-detail @click="handleDetails(scope.row)">查看</ps-detail>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </template>
      </el-tabs>
      <div class="text-page">
        <div class="text" v-if="selectValue == '1'">
          备注： 得分和排名更新时间为
          <span v-if="activeName == 'first' && companyDate.CreateDate"
            >{{
              companyDate.CreateDate | formatDate('yyyy年MM月dd日 00:00:00')
            }}。</span
          >
          <span v-else-if="activeName == 'second' && managerDate.CreateDate"
            >{{
              managerDate.CreateDate | formatDate('yyyy年MM月dd日 00:00:00')
            }}。</span
          >
          <span v-else
            >{{ nowDate | formatDate('yyyy年MM月dd日 hh:mm:ss') }}。</span
          >
          《深圳市物业服务评价管理办法》于2022年1月1日起施行。上一年度评价等级为“-”的，表示其上一年度无评价等级。
          <!-- 根据《深圳市物业服务评价管理办法》第三十八条规定，被纳入风险名单的物业服务企业（项目负责人），不参与纳入时所在自然年度的物业服务评价和等级评定，其评价排名和等级评定情况显示为“-”。 -->
        </div>
        <div class="empty" v-else-if="selectValue == '2'">
          数据更新时间为：
          {{ new Date() | dateFormat('yyyy年MM月dd日 00:00:00') }}
        </div>
        <div class="empty" v-else></div>
        <div class="footer">
          <div class="page">
            <ps-page :page="pages" @getData="getQueryList()"></ps-page>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Page } from '@/models/page';
import { headerredraw } from '@/mixin/headerredraw';
import { CreditEvaQueryController } from '@/service/creditEvaQueryController/creditEvaQueryController.js';
import { CreditEvaApplyController } from '@/service/CreditEvaApplyController/CreditEvaApplyController.js';
import { RegularQueryController } from '@/service/newCreditEvaController/regularQueryController.js';
import filters from '@/filters/index';
import { QueryVo } from '@/models/creditEvaluation/QueryVo';

export default {
  name: 'evaluationSituationList',
  mixins: [headerredraw],
  data() {
    return {
      activeName: 'first',
      loading: false,
      companyEvaluationList: [],
      managerEvaluationList: [],
      companyBaseInfoList: [],
      managerBaseInfoList: [],
      companyGoodList: [],
      managerGoodList: [],
      companyBadList: [],
      managerBadList: [],
      companyRiskList: [],
      managerRiskList: [],
      encourageList: [],
      pages: new Page(),
      companyName: '',
      managerName: '',
      date: {},
      nowDate: new Date().getTime(),
      selectValue: '1',
      parameter: new QueryVo(),
      parameter2: new QueryVo(),
      companyDate: {},
      managerDate: {},
      isShowOption: {},
    };
  },
  created() {
    this.CreditEvaQueryController = new CreditEvaQueryController();
    this.CreditEvaApplyController = new CreditEvaApplyController();
    this.regularQueryController = new RegularQueryController();
    let officialWebsite = JSON.parse(
      window.sessionStorage.getItem('officialWebsite')
    );
    if (officialWebsite && officialWebsite.activeName) {
      this.activeName = officialWebsite.activeName;
      this.selectValue = officialWebsite.selectValue;
      this.companyName = officialWebsite.companyName;
      this.managerName = officialWebsite.managerName;
      this.handleChange();
      if (this.activeName == 'first') {
        this.geInformationManagementVoBtn_public(1);
      } else {
        this.geInformationManagementVoBtn_public(2);
      }
    } else {
      this.getCreditEvaSummaryVOList(1);
      this.geInformationManagementVoBtn_public(1);
    }
    window.sessionStorage.setItem('officialWebsite', JSON.stringify({}));
    this.getCreditEvaRanking(1);
    this.getCreditEvaRanking(2);
  },
  filters: {
    dateFormat: filters.formatDate,
  },
  methods: {
    indexMethod(index) {
      return index + 1 + (this.pages.currentPage - 1) * this.pages.currtNum;
    },
    // 搜索
    handleSearch() {
      this.pages.currentPage = 1;
      this.getQueryList();
    },
    // page相关
    handleSizeChange(val) {
      this.pages.currtNum = val;
      this.getQueryList();
    },
    // page相关
    pageChange(val) {
      this.pages.currentPage = val;
      this.getQueryList();
    },
    getQueryList() {
      this.handleChange();
    },
    // 时间更新  token:String, keyId:String, dateTime:Date, bodyType:int
    // bodyType  1:物业企业 2：项目经理
    getCreditEvaRanking(type) {
      let timeNow = filters.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss');
      this.regularQueryController
        .getCreditEvaRanking_builtBureauWebsite_v1('', timeNow, type, 1, '', '')
        .then((res) => {
          if (res) {
            if (type == 1) {
              this.companyDate = res;
            } else {
              this.managerDate = res;
            }
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 获取信息管理按钮状态
    geInformationManagementVoBtn_public(suitObj) {
      this.parameter2.SuitObj = suitObj;
      this.CreditEvaApplyController.geInformationManagementVoBtn_public(
        JSON.stringify(this.parameter2)
      )
        .then((res) => {
          if (res) {
            this.isShowOption = res;
            if (
              this.selectValue == '3' ||
              this.selectValue == '4' ||
              this.selectValue == '5'
            ) {
              if (this.isShowOption.Good && this.selectValue == '3') {
                this.selectValue = '3';
                this.handleChange();
              } else if (this.isShowOption.Bad && this.selectValue == '4') {
                this.selectValue = '4';
                this.handleChange();
              } else if (this.isShowOption.Risk && this.selectValue == '5') {
                this.selectValue = '5';
                this.handleChange();
              } else {
                this.selectValue = '1';
                this.handleChange();
              }
            }
          }
        })
        .catch((err) => {
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // companyName:String, companyCode:String, eaAreaName:String, managerName:String, orderByItem:int, creditBodyType:int, startIndex:int, maxSize:int
    // 评价情况
    getCreditEvaSummaryVOList(type) {
      this.loading = true;
      this.regularQueryController
        .getCreditEvaSummaryVOList_builtBureauWebsite_v1(
          this.companyName,
          '',
          '',
          '',
          1,
          type,
          (this.pages.currentPage - 1) * this.pages.currtNum,
          this.pages.currtNum,
          this.managerName,
          ''
        )
        .then((res) => {
          this.loading = false;
          this.pages.getCurrtNum = res.TotalCount;
          if (res && res._Items) {
            if (type == 1) {
              this.companyEvaluationList = res._Items;
            } else {
              this.managerEvaluationList = res._Items;
            }
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 物业服务企业基础信息  orgCode:String, orgName:String, creditBodyType:String, isScoreAsc:int, startIndex:int, maxSize:int
    // creditBodyType 1：物业企业 2：物业项目  isScoreAsc：1：升序 0：降序
    getCreditEvaBasicInfoCompanyVOList() {
      this.loading = true;
      this.regularQueryController
        .getCreditEvaBasicInfoCompanyVOList_builtBureauWebsite_v1(
          '',
          this.companyName,
          1,
          0,
          (this.pages.currentPage - 1) * this.pages.currtNum,
          this.pages.currtNum,
          ''
        )
        .then((res) => {
          this.loading = false;
          this.pages.getCurrtNum = res.TotalCount;
          if (res && res._Items) {
            this.companyBaseInfoList = res._Items;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 项目负责人基础信息
    // eaAreaCode:String, eaAreaName:String, creditBodyType:String, isScoreAsc:int, totalScore_l:String, totalScore_r:String, managerName:String, companyName:String, startIndex:int, maxSize:int
    // isScoreAsc 0：倒序 1：升序
    getCreditEvaBasicInfoManagerVOList() {
      this.loading = true;
      this.regularQueryController
        .getCreditEvaBasicInfoManagerVOList_builtBureauWebsite_v1(
          '',
          '',
          2,
          0,
          '',
          '',
          '',
          '',
          (this.pages.currentPage - 1) * this.pages.currtNum,
          this.pages.currtNum,
          this.managerName,
          ''
        )
        .then((res) => {
          this.loading = false;
          this.pages.getCurrtNum = res.TotalCount;
          if (res && res._Items) {
            this.managerBaseInfoList = res._Items;
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 物业服务企业良好信息列表 parameter:QueryVo, startIndex:int, maxSize:int, resultTotalCount:boolean, option:int
    // suitObj 1:物业企业 2：项目负责人  option 1：良好 2：不良 3：风险
    getInformationManagementVoList(suitObj, option) {
      this.loading = true;
      this.parameter.SuitObj = suitObj;
      this.parameter.OrgName = this.companyName;
      // this.parameter.MangerName = this.managerName;
      this.parameter.MangerNameOrEaAreaName = this.managerName;
      this.CreditEvaApplyController.getInformationManagementVoList_builtBureauWebsite(
        JSON.stringify(this.parameter),
        (this.pages.currentPage - 1) * this.pages.currtNum,
        this.pages.currtNum,
        true,
        option,
        1
      )
        .then((res) => {
          this.loading = false;
          this.pages.getCurrtNum = res.TotalCount;
          if (res && res._Items) {
            if (suitObj == 1) {
              if (option == 1) {
                this.companyGoodList = res._Items;
              } else if (option == 2) {
                this.companyBadList = res._Items;
              } else if (option == 3) {
                this.companyRiskList = res._Items;
              }
            } else {
              if (option == 1) {
                this.managerGoodList = res._Items;
              } else if (option == 2) {
                this.managerBadList = res._Items;
              } else if (option == 3) {
                this.managerRiskList = res._Items;
              }
            }
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // 激励名单
    getExcitationExternalList() {
      this.loading = true;
      let nowYear = new Date().getFullYear() -1;
      this.CreditEvaQueryController.getExcitationExternalList(
        nowYear,
        this.companyName,
        (this.pages.currentPage - 1) * this.pages.currtNum,
        this.pages.currtNum,
        true
      )
        .then((res) => {
          this.loading = false;
          if (res) {
            this.pages.getCurrtNum = res.TotalCount;
            if (res._Items) {
              this.encourageList = res._Items;
            }
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message({
            type: 'error',
            message: err.Msg,
          });
        });
    },
    // tab栏切换
    handleTabClick() {
      this.pages.currentPage = 1;
      this.companyName = '';
      this.managerName = '';
      this.handleChange();
      if (this.activeName == 'first') {
        this.geInformationManagementVoBtn_public(1);
      } else {
        this.geInformationManagementVoBtn_public(2);
      }
    },
    // 选项切换
    handleSelect() {
      this.pages.currentPage = 1;
      this.companyName = '';
      this.managerName = '';
      this.handleChange();
    },
    // tab、页签、选项切换
    handleChange() {
      if (this.activeName == 'first') {
        if (this.selectValue == '1') {
          this.getCreditEvaSummaryVOList(1);
        } else if (this.selectValue == '2') {
          this.getCreditEvaBasicInfoCompanyVOList();
        } else if (this.selectValue == '3') {
          this.getInformationManagementVoList(1, 1);
        } else if (this.selectValue == '4') {
          this.getInformationManagementVoList(1, 2);
        } else if (this.selectValue == '5') {
          this.getInformationManagementVoList(1, 3);
        } else if (this.selectValue == '6') {
          this.getExcitationExternalList();
        }
      } else {
        if (this.selectValue == '1') {
          this.getCreditEvaSummaryVOList(2);
        } else if (this.selectValue == '2') {
          this.getCreditEvaBasicInfoManagerVOList();
        } else if (this.selectValue == '3') {
          this.getInformationManagementVoList(2, 1);
        } else if (this.selectValue == '4') {
          this.getInformationManagementVoList(2, 2);
        } else if (this.selectValue == '5') {
          this.getInformationManagementVoList(2, 3);
        }
      }
    },
    // 账号详情
    handleDetails(row) {
      if (this.activeName == 'first') {
        if (this.selectValue == '1') {
          window.sessionStorage.setItem(
            'officialWebsite',
            JSON.stringify({
              activeName: this.activeName,
              selectValue: this.selectValue,
              companyName: this.companyName,
              managerName: this.managerName,
            })
          );
          this.$router.push({
            path: '/evaluationSituationDetail',
            query: {
              orgCode: row.CompanyCode,
              rankId: row.RankId,
              activeName: this.activeName,
              subjectType: 'company',
            },
          });
        } else if (this.selectValue == '2') {
          window.sessionStorage.setItem(
            'officialWebsite',
            JSON.stringify({
              activeName: this.activeName,
              selectValue: this.selectValue,
              companyName: this.companyName,
              managerName: this.managerName,
            })
          );
          this.$router.push({
            path: '/companyBaseDetail',
            query: {
              keyId: row.Id,
              rankId: row.RankId,
              orgCode: row.OrgCode,
              orgName: encodeURIComponent(row.OrgName),
              activeName: this.activeName,
            },
          });
        } else if (this.selectValue == '3') {
          window.sessionStorage.setItem(
            'officialWebsite',
            JSON.stringify({
              activeName: this.activeName,
              selectValue: this.selectValue,
              companyName: this.companyName,
              managerName: this.managerName,
            })
          );
          this.$router.push({
            path: '/officialGoodInfoDetail',
            query: {
              orgCode: row.OrgCode,
              docCode: row.DocCode,
              activeName: this.activeName,
            },
          });
        } else if (this.selectValue == '4') {
          window.sessionStorage.setItem(
            'officialWebsite',
            JSON.stringify({
              activeName: this.activeName,
              selectValue: this.selectValue,
              companyName: this.companyName,
              managerName: this.managerName,
            })
          );
          this.$router.push({
            path: '/officialBadInfoDetail',
            query: {
              orgCode: row.OrgCode,
              docCode: row.DocCode,
              activeName: this.activeName,
            },
          });
        } else if (this.selectValue == '5') {
          window.sessionStorage.setItem(
            'officialWebsite',
            JSON.stringify({
              activeName: this.activeName,
              selectValue: this.selectValue,
              companyName: this.companyName,
              managerName: this.managerName,
            })
          );
          this.$router.push({
            path: '/officialRiskInfoDetail',
            query: {
              orgCode: row.OrgCode,
              docCode: row.DocCode,
              applyContent: encodeURIComponent(row.ApplyContent),
              activeName: this.activeName,
              subjectType: 'company',
            },
          });
        }
      } else {
        if (this.selectValue == '1') {
          window.sessionStorage.setItem(
            'officialWebsite',
            JSON.stringify({
              activeName: this.activeName,
              selectValue: this.selectValue,
              companyName: this.companyName,
              managerName: this.managerName,
            })
          );
          this.$router.push({
            path: '/evaluationSituationDetail',
            query: {
              mob: row.Id,
              managerName: encodeURIComponent(row.ManagerName),
              rankId: row.RankId,
              activeName: this.activeName,
              subjectType: 'manage',
            },
          });
        } else if (this.selectValue == '2') {
          window.sessionStorage.setItem(
            'officialWebsite',
            JSON.stringify({
              activeName: this.activeName,
              selectValue: this.selectValue,
              companyName: this.companyName,
              managerName: this.managerName,
            })
          );
          this.$router.push({
            path: '/officialManagerBaseInfoDetail',
            query: {
              mangerName: encodeURIComponent(row.MangerName),
              keyId: row.Id,
              rankId: row.RankId,
              mob: row.RankId,
              orgCode: row.OrgCode,
              activeName: this.activeName,
            },
          });
        } else if (this.selectValue == '3') {
          window.sessionStorage.setItem(
            'officialWebsite',
            JSON.stringify({
              activeName: this.activeName,
              selectValue: this.selectValue,
              companyName: this.companyName,
              managerName: this.managerName,
            })
          );
          this.$router.push({
            path: '/officialGoodInfoDetail',
            query: {
              mob: row.DocCode,
              docCode: row.DocCode,
              applyContent: encodeURIComponent(row.ApplyContent),
              activeName: this.activeName,
            },
          });
        } else if (this.selectValue == '4') {
          window.sessionStorage.setItem(
            'officialWebsite',
            JSON.stringify({
              activeName: this.activeName,
              selectValue: this.selectValue,
              companyName: this.companyName,
              managerName: this.managerName,
            })
          );
          this.$router.push({
            path: '/officialBadInfoDetail',
            query: {
              mob: row.DocCode,
              docCode: row.DocCode,
              applyContent: encodeURIComponent(row.ApplyContent),
              activeName: this.activeName,
            },
          });
        } else if (this.selectValue == '5') {
          window.sessionStorage.setItem(
            'officialWebsite',
            JSON.stringify({
              activeName: this.activeName,
              selectValue: this.selectValue,
              companyName: this.companyName,
              managerName: this.managerName,
            })
          );
          this.$router.push({
            path: '/officialRiskInfoDetail',
            query: {
              mob: row.DocCode,
              docCode: row.DocCode,
              applyContent: encodeURIComponent(row.ApplyContent),
              activeName: this.activeName,
              subjectType: 'manage',
            },
          });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.officialWebsiteList {
  width: 100%;
  height: 800px;

  .box-card {
    width: 100%;
    height: 100%;
    padding: 14px;

    .search-with-select {
      display: flex;
      // .select{
      //     flex: 3;
      // }
      .search {
        flex: 8;

        .button {
          width: 80px;
        }
      }
    }

    .container {
      height: 560px;
    }

    .text-page {
      display: flex;

      .text {
        flex: 1;
        padding-right: 40px;
      }

      .empty {
        flex: 1;
      }

      .footer {
        flex: 1;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}
</style>
